import React, { useCallback, useEffect, useState } from "react";
import { Box } from "@material-ui/core";
import {
  ProprtyInfoComponent,
  PropertyTimelineComponent,
  PropertyDetailsComponent,
  UnitesComponent,
  LocationComponent,
  PaymentPlanComponent,
  UnitsModelsComponent,
  PropertySpecificationComponent,
  AmenitiesFacilitiesComponent,
} from "./UI";
import {
  GetAllPropertyUnitModelsAPI,
  GetLatitudeAndLongitudeByProperty,
  GetPropertyMarketingByPropertyId,
  GetPropertySpecificationByPropertyId,
  UnitsAdvanceSearchTest,
} from "../../../../../../Services";
import { UnitMapper } from "../../../../UnitsSalesView/UnitMapper";
import { formatPaymentPlansForTableFields } from "../../../../PaymentPlans/models";
import { GetAllPaymentPlans } from "../../../../../../Services/PaymentPlanServices";
import { useQuery } from "../../../../../../Hooks";
import {
  AmenitiesFacilitiesComponentSkeleton,
  LocationComponentSkeleton,
  PropertyDetailsComponentSkeleton,
  PropertySpecificationComponentSkeleton,
  PropertyTimelineComponentSkeleton,
  ProprtyInfoComponentSkeleton,
} from "../../../../../../Components";

//  styles
import useStyles from "./styles";

function PropertyInfo({
  setTabValue,
  propretyId,
  propretyResponseJson,
  propretyResponse,
  isLoadingPropertiesDetailes,
}) {
  const styles = useStyles();
  const query = useQuery();
  const pagination = { pageIndex: 1, pageSize: 25 };
  const initialFilter = (propertyId) => ({
    paymentPlanName: null,
    propertyPlanStatus: null,
    developerName: null,
    propertyId,
    isForSpecificProperty: !!propertyId,
  });
  const filter = initialFilter(propretyId);
  const [FullPropertyMarketing, setFullPropertyMarketing] = useState({});
  const [dataUnit, setDataUnit] = useState({
    result: [],
    totalCount: 0,
  });
  const [paymentData, setPaymentData] = useState([]);
  const [unitModels, setUnitModels] = useState({
    result: [],
    totalCount: 0,
  });
  const [locationData, setLoacationData] = useState({
    latitude: null,
    longitude: null,
  });
  const [isloadingUnits, setIsLoadingUnits] = useState(false);
  const [isLoadingMarkiting, setIsLoadingMarketing] = useState(false);
  const [isLoadingLocation, setIsLoadingLocation] = useState(false);
  const [isLoadingPayment, setIsLoadingPayment] = useState(false);
  const [isLoadingUnitModels, setIsLoadingUnitModels] = useState(false);
  const [isLoadingSpaceficProprety, setIsLoadingSpacificProprety] =
    useState(false);

  const defaultState = {
    propertyId: query.get("id"),
    numberOfApartment: 0,
    minApartmentArea: 0,
    maxApartmentArea: 0,
    numberOfApartmentStudio: 0,
    numberOfApartmentPenthouse: 0,
    numberOfApartmentOneBedroom: 0,
    numberOfApartmentTowBedroom: 0,
    numberOfApartmentThreeBedroom: 0,
    numberOfApartmentFourBedroom: 0,
    numberOfApartmentFiveBedroom: 0,
    numberOfApartmentBedroomMoreThanFive: 0,
    numberOfVilla: 0,
    minVillaArea: 0,
    maxVillaArea: 0,
    numberOfVillaStudio: 0,
    numberOfVillaPenthouse: 0,
    numberOfVillaOneBedroom: 0,
    numberOfVillaTowBedroom: 0,
    numberOfVillaThreeBedroom: 0,
    numberOfVillaFourBedroom: 0,
    numberOfVillaFiveBedroom: 0,
    numberOfVillaBedroomMoreThanFive: 0,
    retailUnitGrossArea: 0,
    minRetailUnitArea: 0,
    maxRetailUnitArea: 0,
    officeGrossArea: 0,
    minOfficeArea: 0,
    maxOfficeArea: 0,
    laborCampGrossArea: 0,
    minLaborCampArea: 0,
    maxLaborCampArea: 0,
    wareHouseGrossArea: 0,
    minWareHouseArea: 0,
    maxWareHouseArea: 0,
    numberOfRetail: 0,
    numberOfOffices: 0,
    numberOfPentHouse: 0,
    minPentHouseArea: 0,
    maxPentHouseArea: 0,
    minStudioArea: 0,
    maxStudioArea: 0,
    numberOfStudio: 0,
    minTownHouseArea: 0,
    maxTownHouseArea: 0,
    numberOfTownHouse: 0,
    numberOfStudioOneBedroom: 0,
    numberOfStudioTowBedroom: 0,
    numberOfStudioThreeBedroom: 0,
    numberOfStudioFourBedroom: 0,
    numberOfStudioFiveBedroom: 0,
    numberOfStudioBedroomMoreThanFive: 0,
    numberOfTownHouseOneBedroom: 0,
    numberOfTownHouseTowBedroom: 0,
    numberOfTownHouseThreeBedroom: 0,
    numberOfTownHouseFourBedroom: 0,
    numberOfTownHouseFiveBedroom: 0,
    numberOfTownHouseBedroomMoreThanFive: 0,
    numberOfPentHouseOneBedroom: 0,
    numberOfPentHouseTowBedroom: 0,
    numberOfPentHouseThreeBedroom: 0,
    numberOfPentHouseFourBedroom: 0,
    numberOfPentHouseFiveBedroom: 0,
    numberOfPentHouseBedroomMoreThanFive: 0,
  };

  const [propertypeScificationData, setPropertypeScificationData] =
    useState(defaultState);


  const getPropertyMarketingByPropertyId = useCallback(async () => {
    setIsLoadingMarketing(true);
    const res = await GetPropertyMarketingByPropertyId(propretyId);

    if (!(res && res.status && res.status !== 200)) {
      if (res && res.length > 0) {
        setFullPropertyMarketing(res);
      }
    }
    setIsLoadingMarketing(false);
  }, [propretyId]);

  const getUnitsSale = async () => {
    setIsLoadingUnits(true);
    try {
      const criteria = {
        propertyId: [
          {
            searchType: 1,
            value: propretyId,
          },
        ],
      };
      const body = {
        criteria,
        filterBy: "createdOn",
        orderBy: 2,
        OperationType: "Sale",
      };
      const res = await UnitsAdvanceSearchTest(
        { pageIndex: 0, pageSize: 10 },
        body
      );
      if (!(res && res.status && res.status !== 200)) {
        const units = ((res && res.result) || []).map(
          (item) =>
            item.unitJson && UnitMapper(item, JSON.parse(item.unitJson).unit)
        );
        setDataUnit({
          result: units || [],
          totalCount: res.totalCount,
        });
      } else
        setDataUnit({
          result: [],
          totalCount: 0,
        });
    } catch (error) {
    } finally {
      setIsLoadingUnits(false);
    }
  };

  const getAllPaymentPlans = useCallback(async () => {
    setIsLoadingPayment(true);
    try {
      const body = { ...pagination, ...filter };
      const res = await GetAllPaymentPlans(body);
      res.result = formatPaymentPlansForTableFields(res.result);
      setPaymentData(res);
    } catch (error) {
    } finally {
      setIsLoadingPayment(false);
    }
  }, []);

  const getAllUnitModelAndFilesByPropertyId = useCallback(async () => {
    setIsLoadingUnitModels(true);
    const res =
      propretyId &&
      (await GetAllPropertyUnitModelsAPI({
        propertyId: propretyId,
        pageIndex: 1,
        pageSize: 100,
      }));

    if (!((res && res.data && res.data.ErrorId) || !res)) {
      setUnitModels({
        result: (res && res.result) || [],
        totalCount: res.totalCount,
      });
    } else setUnitModels({ result: [], totalCount: 0 });
    setIsLoadingUnitModels(false);
  }, [propretyId]);

  const getMapByFormId = useCallback(async (Id) => {
    setIsLoadingLocation(true);
    const result = await GetLatitudeAndLongitudeByProperty(Id);

    setLoacationData({
      latitude: result.latitude,
      longitude: result.longitude,
    });
    setIsLoadingLocation(false);
  }, []);

  const GetSpecificationById = useCallback(async () => {
    setIsLoadingSpacificProprety(true);
    const result = await GetPropertySpecificationByPropertyId(query.get("id"));
    if (!(result && result.status && result.status !== 200)) {
      setPropertypeScificationData({ ...result, propertyId: query.get("id") });

    } else {
      setPropertypeScificationData(defaultState);
    }
    setIsLoadingSpacificProprety(false);
  }, []);

  useEffect(() => {
    getPropertyMarketingByPropertyId();
    getUnitsSale();
    getAllPaymentPlans();
    getAllUnitModelAndFilesByPropertyId();
    GetSpecificationById();
  }, []);

  useEffect(() => {
    const editId = query.get("id");
    if (editId !== null) getMapByFormId(editId);
  }, [propretyId, getMapByFormId]);


  return (
    <Box className={styles.containerPropretyInfo}>
      <Box className={styles.containerFirstCol}>
        {isLoadingMarkiting || isLoadingPropertiesDetailes ? (
          <ProprtyInfoComponentSkeleton />
        ) : (
          <ProprtyInfoComponent
            propretyId={propretyId}
            propretyResponseJson={propretyResponseJson}
            propretyResponse={propretyResponse}
            fullPropertyMarketing={FullPropertyMarketing}
            isLoadingMarkiting={isLoadingMarkiting}
            isLoadingPropertiesDetailes={isLoadingPropertiesDetailes}
          />
        )}
        {isLoadingPropertiesDetailes ? (
          <Box className={styles.containerPropretyDetailTimeLine}>
            <PropertyDetailsComponentSkeleton />
            <PropertyTimelineComponentSkeleton />
          </Box>
        ) : (
          <Box className={styles.containerPropretyDetailTimeLine}>
            <PropertyDetailsComponent
              propretyId={propretyId}
              propretyResponseJson={propretyResponseJson}
              propretyResponse={propretyResponse}
            />
            <PropertyTimelineComponent
              propretyId={propretyId}
              propretyResponseJson={propretyResponseJson}
              propretyResponse={propretyResponse}
            />
          </Box>
        )}
        {(dataUnit?.result?.length > 0 || isloadingUnits) && (
          <UnitesComponent
            setTabValue={setTabValue}
            propretyId={propretyId}
            dataUnit={dataUnit}
            isloadingUnits={isloadingUnits}
          />
        )}

        {(paymentData?.result?.length > 0 || isLoadingPayment) && (
          <PaymentPlanComponent
            setTabValue={setTabValue}
            propretyId={propretyId}
            paymentData={paymentData}
            isLoadingPayment={isLoadingPayment}
          />
        )}

        {isLoadingPropertiesDetailes ? (
          <AmenitiesFacilitiesComponentSkeleton
            isLoadingPropertiesDetailes={isLoadingPropertiesDetailes}
          />
        ) : (
          <AmenitiesFacilitiesComponent
            setTabValue={setTabValue}
            propretyId={propretyId}
            propretyResponseJson={propretyResponseJson}
          />
        )}
        {(unitModels?.result?.length > 0 || isLoadingUnitModels) && (
          <UnitsModelsComponent
            propretyId={propretyId}
            setTabValue={setTabValue}
            unitModels={unitModels}
            isLoadingUnitModels={isLoadingUnitModels}
          />
        )}
      </Box>
      <Box className={styles.containerSecCol}>
        {isLoadingLocation ? (
          <LocationComponentSkeleton />
        ) : (
          <>
            {locationData?.latitude && locationData?.longitude && (
              <LocationComponent
                propretyId={propretyId}
                locationData={locationData}
                setLoacationData={setLoacationData}
                propretyResponseJson={propretyResponseJson}
              />
            )}
          </>
        )}
        {isLoadingSpaceficProprety ? (
          <PropertySpecificationComponentSkeleton />
        ) : (
            <PropertySpecificationComponent
              setTabValue={setTabValue}
              propretyId={propretyId}
              propertypeScificationData={propertypeScificationData}
            />
        )}
      </Box>
    </Box>
  );
}

export default PropertyInfo;
